export default async ({ store }) => {
  const { default: createPersistedState } = await import('vuex-persistedstate')
  const options = { key: 'properties', paths: ['properties'] }

  createPersistedState(options)(store)
}
